/**
 * Context shared between TeachingPopoverCarousel and its children components
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
